/* Product configurator: order fields (line item properties), add-on products and the
   remembered vehicle are sent together with the main variant in one /cart/add.js call. */
(function () {
  "use strict";
  var I18N = (window.HLC && window.HLC.i18n) || {};
  function T(k, d) { return I18N[k] || d; }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  $$("[data-hlc-configurator]").forEach(function (cfg) {
    var form = cfg.closest("form") || $("form[data-type='add-to-cart-form']");
    var productForm = form && form.closest("product-form");
    if (!form) return;
    var money = function (cents) {
      var cur = cfg.getAttribute("data-currency") || "EUR";
      try { return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: cur }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + " " + cur; }
    };
    var mainPriceEl = $("[data-hlc-main-price]", cfg);
    var totalEl = $("[data-hlc-total]", cfg);
    var errorEl = $("[data-hlc-error]", cfg);

    function mainVariantPrice() {
      var v = parseInt(cfg.getAttribute("data-main-price") || "0", 10);
      var id = form.querySelector("[name='id']") && form.querySelector("[name='id']").value;
      var map = window.HLC_VARIANT_PRICES || {};
      if (id && map[id] != null) v = map[id];
      return v;
    }
    function addonSelections() {
      var items = [];
      $$("[data-addon]", cfg).forEach(function (box) {
        if (box.hidden) return;                                   // requirement not met (see syncConditional)
        var enabled = box.getAttribute("data-addon-required") === "true";
        var chk = $("[data-addon-toggle]", box);
        if (chk) enabled = chk.checked;
        if (!enabled) return;
        var variantId = box.getAttribute("data-addon-variant");
        var sel = $("[data-addon-variant-select]", box);
        var price = parseInt(box.getAttribute("data-addon-price") || "0", 10);
        if (sel) {
          variantId = sel.value;
          var opt = sel.options[sel.selectedIndex];
          price = parseInt(opt.getAttribute("data-price") || "0", 10);
        }
        // two-option add-on (bars × finish): resolve variant from the two selects
        var selA = $("[data-addon-opt='1']", box), selB = $("[data-addon-opt='2']", box);
        if (selA && selB) {
          var key = selA.value + "|" + selB.value;
          var table = JSON.parse(box.getAttribute("data-addon-table") || "{}");
          var hit = table[key];
          if (!hit) return items.push({ error: box.getAttribute("data-addon-label") + ": " + T("combination_unavailable", "this combination is not available.") });
          variantId = hit.id; price = hit.price;
        }
        if (!variantId) return;
        items.push({ id: parseInt(variantId, 10), quantity: 1, label: box.getAttribute("data-addon-label"), price: price, box: box, kind: box.getAttribute("data-addon-kind") });
      });
      return items;
    }
    function updateTotal() {
      syncConditional();
      var total = mainVariantPrice();
      var lines = [];
      addonSelections().forEach(function (a) { if (!a.error) { total += a.price; } });
      if (mainPriceEl) mainPriceEl.textContent = money(mainVariantPrice());
      if (totalEl) totalEl.textContent = money(total);
      $$("[data-addon]", cfg).forEach(function (box) {
        var out = $("[data-addon-price-out]", box);
        if (!out) return;
        var sel = $("[data-addon-variant-select]", box), selA = $("[data-addon-opt='1']", box), selB = $("[data-addon-opt='2']", box);
        var price = parseInt(box.getAttribute("data-addon-price") || "0", 10);
        if (sel) price = parseInt(sel.options[sel.selectedIndex].getAttribute("data-price") || "0", 10);
        if (selA && selB) { var table = JSON.parse(box.getAttribute("data-addon-table") || "{}"); var hit = table[selA.value + "|" + selB.value]; price = hit ? hit.price : null; }
        out.textContent = price == null ? "n/a" : (price === 0 ? "included" : "+ " + money(price));
      });
    }
    /* fields with show_if (e.g. engraving text / font / logo) only for matching variants */
    var variantOptions = {};
    try { variantOptions = JSON.parse(cfg.getAttribute("data-variant-options") || "{}"); } catch (e) { variantOptions = {}; }
    function syncConditional() {
      var idEl = form.querySelector("[name='id']");
      var opts = (idEl && variantOptions[idEl.value]) || [];           // value index per option, language independent
      $$("[data-show-if-opt]", cfg).forEach(function (wrap) {
        var oi = parseInt(wrap.getAttribute("data-show-if-opt"), 10);
        var vals = String(wrap.getAttribute("data-show-if-vals") || "").split(",").filter(Boolean).map(Number);
        var show = vals.indexOf(opts[oi]) > -1;
        wrap.hidden = !show;
        $$("[data-hlc-field]", wrap).forEach(function (f) { f.disabled = !show; });
      });
      /* add-ons that require another add-on (data-addon-requires = kind) or a main option value */
      $$("[data-addon]", cfg).forEach(function (box) {
        var req = box.getAttribute("data-addon-requires"), ro = box.getAttribute("data-addon-requires-opt");
        if (req === null && ro === null) return;
        var ok = true;
        if (req !== null) { var rb = cfg.querySelector("[data-addon][data-addon-kind='" + req + "']"); var rt = rb && rb.querySelector("[data-addon-toggle]"); ok = !!(rb && !rb.hidden && (!rt || rt.checked)); }
        if (ro !== null) { var rv = String(box.getAttribute("data-addon-requires-vals") || "").split(",").filter(Boolean).map(Number); ok = ok && rv.indexOf(opts[parseInt(ro, 10)]) > -1; }
        box.hidden = !ok;
        if (!ok) { var t = box.querySelector("[data-addon-toggle]"); if (t) t.checked = false; }
      });
      /* fields that depend on an add-on variant (engraving text / font / logo for the Alcantara strip) */
      $$("[data-show-if-addon]", cfg).forEach(function (wrap) {
        var box = cfg.querySelector("[data-addon][data-addon-handle='" + wrap.getAttribute("data-show-if-addon") + "']");
        var vals = String(wrap.getAttribute("data-show-if-addon-vals") || "").split(",").filter(Boolean).map(Number);
        var show = false;
        if (box && !box.hidden) { var t = box.querySelector("[data-addon-toggle]"), sel = box.querySelector("[data-addon-variant-select]"); show = (!t || t.checked) && (!sel || vals.indexOf(sel.selectedIndex) > -1); }
        wrap.hidden = !show;
        $$("[data-hlc-field]", wrap).forEach(function (f) { f.disabled = !show; });
      });
    }
    cfg.addEventListener("change", updateTotal);
    cfg.addEventListener("input", updateTotal);
    document.addEventListener("change", function (e) { if (form.contains(e.target)) updateTotal(); });
    var obs = new MutationObserver(updateTotal);
    var idInput = form.querySelector("[name='id']");
    if (idInput) obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    updateTotal();

    /* colour surcharge on the swatches: min variant price of the colour minus the cheapest variant */
    (function annotateSwatches() {
      var prices = window.HLC_VARIANT_PRICES || {};
      var ids = Object.keys(variantOptions);
      if (!ids.length) return;
      var base = Math.min.apply(null, ids.map(function (id) { return prices[id]; }).filter(function (v) { return v != null; }));
      $$("[data-swatch-for]", cfg).forEach(function (grid) {
        var oi = parseInt(grid.getAttribute("data-swatch-for"), 10) - 1;
        var minByIdx = {};
        ids.forEach(function (id) { var vi = variantOptions[id][oi]; if (prices[id] == null) return; if (minByIdx[vi] == null || prices[id] < minByIdx[vi]) minByIdx[vi] = prices[id]; });
        $$("label.ak-swatch", grid).forEach(function (lab, i) {
          var plus = minByIdx[i] != null ? minByIdx[i] - base : 0;
          if (plus > 0 && !lab.querySelector(".ak-swatch__plus")) { var em = document.createElement("em"); em.className = "ak-swatch__plus"; em.textContent = "+" + money(plus).replace(/\s/g, "").replace(/[.,]00$/, ""); lab.appendChild(em); lab.title = lab.title + " (" + money(plus) + ")"; }
        });
      });
    })();
    /* net colour swatches drive the real option select */
    $$("[data-swatch-for]", cfg).forEach(function (grid) {
      var optionIndex = grid.getAttribute("data-swatch-for");
      grid.addEventListener("change", function (e) {
        var val = e.target.value;
        var optionName = grid.getAttribute("data-swatch-name") || "";
        var select = form.querySelector("select[name='options[" + optionName + "]']") || document.querySelector("select[name='options[" + optionName + "]']")
          || document.querySelectorAll("variant-selects select")[parseInt(optionIndex, 10) - 1] || null;
        var radio = document.querySelector("input[type='radio'][name='options[" + optionIndex + "]'][value='" + CSS.escape(val) + "']");
        if (select) { select.value = val; select.dispatchEvent(new Event("change", { bubbles: true })); }
        else if (radio) { radio.checked = true; radio.dispatchEvent(new Event("change", { bubbles: true })); }
      });
      // keep swatches in sync with the select
      var select = document.querySelector("select[name='options[" + optionName + "]']") || document.querySelectorAll("variant-selects select")[parseInt(optionIndex, 10) - 1];
      if (select) select.addEventListener("change", function () {
        var r = grid.querySelector("input[value='" + CSS.escape(select.value) + "']"); if (r) r.checked = true;
      });
    });

    /* intercept submit */
    form.addEventListener("submit", function (e) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ""; }
      var props = {};
      var files = {};
      var missing = [];
      $$("[data-hlc-field]", cfg).forEach(function (f) {
        if (f.disabled) return;                                   // hidden conditional field
        var label = f.getAttribute("data-hlc-field");
        if (f.type === "file") {
          var file = f.files && f.files[0];
          if (file) {
            if (file.size > 20 * 1024 * 1024) { missing.push(label + " (max. 20 MB)"); return; }
            files[label] = file;
          } else if (f.required) { missing.push(label); }
          return;
        }
        var val = (f.value || "").trim();
        if (f.required && !val) missing.push(label);
        if (val) props[label] = val;
      });
      var vehicle = window.hlcVehicle && window.hlcVehicle.get();
      var universal = cfg.getAttribute("data-universal") === "true";
      var vehicleField = $("[data-hlc-vehicle-field]", cfg);
      if (vehicleField && vehicleField.value.trim()) props["Vehicle"] = vehicleField.value.trim();
      else if (vehicle) props["Vehicle"] = vehicle.label + (vehicle.year ? " (" + vehicle.year + ")" : "");
      if (universal && !props["Vehicle"]) missing.push("Vehicle");
      var addons = addonSelections();
      var addonErr = addons.filter(function (a) { return a.error; })[0];
      if (missing.length || addonErr) {
        var msg = addonErr ? addonErr.error : T("please_fill_in", "Please fill in:") + " " + missing.join(", ");
        if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; errorEl.scrollIntoView({ block: "center", behavior: "smooth" }); }
        return;
      }
      var mainId = parseInt(form.querySelector("[name='id']").value, 10);
      var qty = parseInt((form.querySelector("[name='quantity']") || {}).value || "1", 10) || 1;
      var items = [{ id: mainId, quantity: qty, properties: props }];
      addons.forEach(function (a) {
        var p = { "For": cfg.getAttribute("data-product-title") };
        if (props["Vehicle"]) p["Vehicle"] = props["Vehicle"];
        if (a.label && a.label.indexOf("carpet") > -1 && props["Carpet stitching color (if carpet ordered)"]) p["Stitching color"] = props["Carpet stitching color (if carpet ordered)"];
        if (a.kind === "alcantara") { Object.keys(props).forEach(function (k) { if (k.indexOf("Engraving") === 0) p[k] = props[k]; }); }
        items.push({ id: a.id, quantity: qty, properties: p });
      });
      var btn = form.querySelector("[type='submit']");
      if (btn) { btn.setAttribute("aria-disabled", "true"); btn.classList.add("loading"); }
      function postJson(list) {
        return fetch(window.routes.cart_add_url + ".js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: list }) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
      }
      function postMultipart(item) {                               // file uploads need multipart/form-data (one item per call)
        var fd = new FormData();
        fd.append("id", item.id); fd.append("quantity", item.quantity);
        Object.keys(item.properties).forEach(function (k) { fd.append("properties[" + k + "]", item.properties[k]); });
        Object.keys(files).forEach(function (k) { fd.append("properties[" + k + "]", files[k], files[k].name); });
        return fetch(window.routes.cart_add_url, { method: "POST", headers: { "Accept": "application/javascript" }, body: fd })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
      }
      var hasFiles = Object.keys(files).length > 0;
      var first = hasFiles ? postMultipart(items[0]) : postJson(items);
      first
        .then(function (res) {
          if (!res.ok) { throw new Error(res.body.description || res.body.message || T("could_not_add", "Could not add to cart.")); }
          if (hasFiles && items.length > 1) return postJson(items.slice(1));
          return res;
        })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.body.description || res.body.message || T("could_not_add", "Could not add to cart.")); }
          window.location.href = window.routes.cart_url;
        })
        .catch(function (err) {
          if (btn) { btn.removeAttribute("aria-disabled"); btn.classList.remove("loading"); }
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
    }, true);
  });
})();
